import React ,{Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, change ,reset} from 'redux-form';

//Material ui components
import {Button,Grid,} from '@material-ui/core'
import Popover from '@material-ui/core/Popover';
import Slide from '@material-ui/core/Slide';

//engage Components
import {
    SimpleSelect,
} from '../../utils/engageComponents';

const validate = (values) => {
  };


export class ActivityFiltersDrawer extends Component{
    constructor(props){
        super();
        this.state={
            //filterObj
            filterObj: undefined,

            //CategoryFilter
            openCategoryFilterSelect: false,
            categorySelected:undefined,

            //ActivityFilter
            openActivityFilterSelect: false,
            ActivitySelected: undefined,
        }    

        props.dispatch(change('SchedulerFiltersForm','FiltersActivity', ''));
        props.dispatch(change('SchedulerFiltersForm','FiltersCategory', ''));
    };


    //#region Methods
    componentDidMount = ()=>{
        window.addEventListener('resize', this.resize);


        if(this.props){

            if(this.props.idAnchorEl){
                this.setAnchorEl(this.props.idAnchorEl)
            }
            
        }

    }

    componentWillUnmount= () =>{
        window.removeEventListener('resize', this.resize);
    }

    resize = ()=> {
        if(this.props && this.props.idAnchorEl){
            //this.props.onCloseActivityDetails();
            this.setAnchorEl(this.props.idAnchorEl)
        }           
    };


    setAnchorEl(idAnchorEl){
        const anchorEl = document.getElementById(idAnchorEl);

        if(anchorEl){
            this.setState({anchorEl: anchorEl})
        }
    };

    renderFilters(filterObj){
        
        let categorySelected= undefined;
        let activitySelected= undefined;

        if(filterObj.categoryFilter){
            categorySelected = this.props.categories.find(item => item.name === filterObj.categoryFilter);
        }

        
        if(filterObj.activityFilter){
            activitySelected = this.props.activities.find(item => item.name === filterObj.activityFilter);
        }

        this.props.dispatch(change('SchedulerFiltersForm','FiltersActivity', activitySelected));
        this.props.dispatch(change('SchedulerFiltersForm','FiltersCategory', categorySelected));
        
        this.setState({
            categorySelected: categorySelected,
            ActivitySelected: activitySelected,
        })
    };

    handlerChangeOptionSelected = (newCategoriFilter) => {

        this.setState({ categorySelected: newCategoriFilter},
            ()=>{
                if(newCategoriFilter && newCategoriFilter.id !== '000'){
                    const oldFilterObj = this.props.filterObj? this.state.filterObj : {};
        
                    const newFilterObj ={...oldFilterObj , categoryFilter: newCategoriFilter.name}
        
                    this.props.onFilterChange(newFilterObj)
                }
            })

        
    };

       handlerChangeOptionSelectedActivity = (newActivityFilter) =>{

            this.setState({ ActivitySelected: newActivityFilter}, () =>{
                if(newActivityFilter && newActivityFilter.id !== '000'){
                    const oldFilterObj = this.props.filterObj? this.state.filterObj : {};
    
                    const newFilterObj ={...oldFilterObj , activityFilter: newActivityFilter.name}
    
                    this.props.onFilterChange(newFilterObj)
                }
            })            
       }

       handlerCleanFilters = () =>{
            const newFilterObj = this.props.filterObj? {...this.props.filterObj} : {};

            delete newFilterObj.categoryFilter;
            delete newFilterObj.activityFilter;

            this.props.onFilterChange(newFilterObj);

            this.setState({
                //filterObj
                filterObj: undefined,

                //CategoryFilter
                openCategoryFilterSelect: false,
                categorySelected:undefined,

                //ActivityFilter
                openActivityFilterSelect: false,
                ActivitySelected: undefined,
            });        
            
            this.props.dispatch(reset('SchedulerFiltersForm'));
            this.props.dispatch(change('SchedulerFiltersForm','FiltersActivity', ''));
            this.props.dispatch(change('SchedulerFiltersForm','FiltersCategory', ''));
       }
    //#endregion


    //#region INNER COMPONENTS
    FiltersConponent = () =>{
        const styles={
            container:{
                position:'relative'
            },
            titleContainer:{
            },
            filterContainer:{
                marginTop:'35px',
                borderRadius:'15px',
                border:'1px solid white',

            },
            spaceFillerContainer:{
                height:'100px'
            },
            resetFiltersContainer:{
                padding:'25px',
                position:'absolute',
                right:'0',
                bottom:'0',
            }
        }

        return(
            <Grid item container className='popOverFilterContainer' style={{...styles.container}}>
                <Grid item container  style={{...styles.titleContainer}}>
                    <this.TitleComponent/>
                </Grid>
                <Grid item container style={{...styles.filterContainer}}>
                    <this.ActivitiesFilterComponent/>
                </Grid>
                <Grid item container style={{...styles.filterContainer}}>
                    <this.CategoriesFilterComponent/>
                </Grid>
                <Grid item container style={{...styles.spaceFillerContainer}}>
                    {/* this container is empty to keep the space */}
                </Grid>
                <Grid item style={{...styles.resetFiltersContainer}}>
                    <this.ResetFiltersComponent/>
                </Grid>
            </Grid>
        );
    };

    TitleComponent= () => {
        return(
        <Grid item container>
            <Grid item className='popOverFiltersTitle'>Filters</Grid>
        </Grid>);
    };

    ActivitiesFilterComponent = () =>{
        const activitySelected = this.state.ActivitySelected? this.state.ActivitySelected: {}; 
        return(
            <Grid item  
            xs={12} 
            style={{paddingLeft:'15px', marginRight:'15px'}} 
            justify='center'
            onBlur={() => {this.setState({openActivityFilterSelect: false});}}
            onClick={() => {this.setState ((prevState) =>({openActivityFilterSelect: !prevState.openActivityFilterSelect}));} } >
                 <SimpleSelect
                    idToSet='activity_filters_dropdown'
                    showLabel={true}
                    label={'Activity'}
                    open={this.state.openActivityFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedActivity(newItem)}
                    optionsItemsIconsData = {(this.props.activities )? this.props.activities: []}
                    selected={activitySelected}
                    disabled= { false}
                    error={ undefined}
                    helperText = { undefined}
                    autoFocus={true}
                    stylesObj={{underline:'noBorderStyle'}}
                />
            </Grid>
            );
    };

    CategoriesFilterComponent = () =>{
        const categorySelected = this.state.categorySelected? this.state.categorySelected : {};

        return(
            <Grid item  
                xs={12} 
                style={{paddingLeft:'15px', marginRight:'15px'}} 
                justify='center' 
                onBlur={() => this.setState({openCategoryFilterSelect: false})}
                onClick={() => this.setState ((prevState) =>({openCategoryFilterSelect: !prevState.openCategoryFilterSelect}))}
            >
                <SimpleSelect
                    idToSet='activity_filters_categories_dropdown'
                    showStartAdornment={true}
                    showLabel={true}
                    label={'Category'}
                    open={this.state.openCategoryFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelected(newItem)}
                    optionsItemsIconsData = {this.props.categories? this.props.categories : []}
                    selected={categorySelected}
                    disabled= { false}
                    error={ undefined}
                    helperText = { undefined}
                    autoFocus={true}
                    stylesObj={{underline:'noBorderStyle'}}
                />
            </Grid>
        );
    };
    

    ResetFiltersComponent = () =>{
        const handleSubmit = this.props.handleSubmit;

        return(
            <Button id='activity_filters_reset_btn' className='appbtn-engage skybluebtn-engage appbtnBarButton textTransform' onClick={handleSubmit(this.onSubmitHandler.bind(this))}>Reset</Button>
        );
    }

    onSubmitHandler = (form) => {
        this.handlerCleanFilters();
    }
    //#endregion


    render(){
     
        if(this.props.filterObj !== this.state.filterObj){
            this.setState({filterObj: this.props.filterObj? this.props.filterObj : {}}, () =>{
                this.renderFilters(this.props.filterObj);
            })            
        }

        return(
            <>
            {
                this.state.anchorEl?
                    <Popover
                        id="ActivityFilterPopOver"
                        open={true}
                        onClose={this.props.onClose}
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        
                        PaperProps={{
                            className:'popOverFilter',
                        }}
                        elevation={0}
                    >
                        <Slide in={true} direction='left' timeout={600} mountOnEnter unmountOnExit>
                            <Grid  className='popOverFilterSlide' style={{height:'100%'}}>
                                <form>
                                    <this.FiltersConponent/>
                                   
                                </form>
                            </Grid>
                        </Slide>
                    </Popover>
                :
                undefined
            }
            </>
            )
    }
}


function mapStateToProps(state){  
    
    return{ };
};

export default connect(mapStateToProps, {})(reduxForm({
    form: 'SchedulerFiltersForm',
    validate,
})(ActivityFiltersDrawer));